import React, { memo } from "react";
import "./reconocimientos.scss";
import "../../../../components/atoms/buttons/button.scss";
import "../../../../pages/login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import { useNavigate } from "react-router-dom";

const Reconocimientos = ({ reconocimientos, loading }) => {
  const navigate = useNavigate();
  // const [show, setShow] = useState({
  //   mensaje: false,
  // });
  // const [showPDF, setShowPDF] = useState(false);
  // const [pdfBlob, setPdfBlob] = useState(null);

  // Funciones para manejar apertura y cierre de modal de mensajes
  // const handleShow = (e) => setShow(e);
  // const handleClose = () => setShow({ mensaje: false });

  // Función para cerrar modal PDF
  // const handleClosePDF = () => setShowPDF(false);

  const accionRec = {
    name: "Acción",
    right: true,
    cell: (row) => (<>
      <i
        className="fa-solid fa-eye fs-3 mx-2 px-3 cursorPointer faHover"
        onClick={() => {
          // enviar peticion al pagina de muestra ya que puede la peticion devolver tanto el mensaje como el pdf
          // getMensajesReconocimientos(row.x_cabactadm).then((data) => {
          //   
            
          //   // Verificar si el resultado es un Blob para mostrar en el modal PDF
          //   if (data instanceof Blob) {
          //     setPdfBlob(data);  // Asignar directamente el Blob recibido
          //     setShowPDF(true);   // Mostrar el modal PDF
          //   } else {
          //     handleShow({
          //       mensaje: true,
          //       content: data,
          //       tipo: "tituloBorrador",
          //       destinoCerrar: null,
          //     });
          //   }
          // });
          navigate(`/rnsolicitudpdf/${row.x_cabactadm}`)
        }}
        tabIndex={0}
        title="Ver Reconocimiento"
        aria-label="Ver Reconocimiento"
        role="button"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            navigate(`/rnsolicitudpdf/${row.x_cabactadm}`);
          }
        }}
      />
      {/* {showPDF && (
        <ModalPDFViewer
          show={showPDF}
          handleClose={() => handleClosePDF}
          pdfBlob={pdfBlob}  // Enviar el Blob como prop
        />
      )} */}
    </>),
  };

  return (
    <>
      <div className="container-fluid" style={{ marginTop: "0px" }} role="main" data-landmark-index="4">
        {loading ? (
          <DataTable
            className="table-responsive"
            columns={[...ConstantesTabla.columnasReconocimientos, accionRec]}
            data={reconocimientos}
            pagination
            paginationComponentOptions={ConstantesTabla.paginacionOpt}
            noDataComponent={<span>No se encontró ningún reconocimiento</span>}
            customStyles={ConstantesTabla.customStyles}
            fixedHeader
            fixedHeaderScrollHeight="600px"
          />
        ) : (
          <SpinnerCircle />
        )}
      </div>

      {/* Modal de mensajes */}
      {/* {show.mensaje && (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.titulo}
          tipo={show.tipo}
          content={show.content}
          content2={show.content2}
          contentBold={show.contentBold}
          otherContent={show.otherContent}
          destinoCerrar={show.destinoCerrar}
        />
      )} */}

      {/* Modal de PDF */}
      
    </>
  );
};

export default memo(Reconocimientos);
